import axios from 'axios';
import router from './router';

const service = axios.create({
    timeout: 8000
});

const tokenParamName = document.querySelector("meta[name='csrf-param']").getAttribute("content"),
    token = document.querySelector("meta[name='csrf-token']").getAttribute("content");

service.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'multipart/form-data';
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['X-CSRF-Token'] = token;
    
    if(config.method !== "get"){
        config.data.append(tokenParamName, token);
    }
    
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
});

service.interceptors.response.use(
    response => response,
    error => {
        console.log(error);
        if(error.response && error.response.status === 401){
            router.push({path: '/login'});
        }
        return Promise.reject(error.response)
    }
);

export { service };
